import React from 'react'
import { connect } from 'react-redux'

import { Modal } from 'react-bootstrap'

import { bookCar } from "../../model/car"

import { commonErr } from "../common/errors"
import { CarTransmission, isPhoneValid, formatPrice, WDTypes, MiAppMap} from '../common/common'

const MODE = {
	PLATFORM: 1, 
	BIZ: 2
}


class BookingResult extends React.Component {
	
	render() {

		const {err, errMsg, trip } = this.props;

		if (err >= commonErr.SUCCESS) {
				return <div className="form-default form-s">
					<div className="text-center p-4">
						<i className="ic ic-verify" /> Yêu cầu đặt xe của bạn đã được gửi đến Mioto, vui lòng chờ Mioto xác nhận để hoàn tất việc đặt xe.
						<div className="mb-4" />
						<div className="wrap-btn">
							<a href={`/trip/detail/${trip.id}`} className="btn btn-primary btn--m" >Xem chi tiết</a>
						</div>
					</div>
				</div>
			
		} else {
			return <div className="form-default form-s">
				<div className="text-center p-4">
					<i className="ic ic-error" /> Đặt xe thất bại. {errMsg}.
				</div>
			</div>
		}
	}
}

class BookingDetail extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",

			priceSummary: null,
			renterName: "",
			email: "",
			paper: "",
			requiredPapers: [],
			requiredPapersOther: "",
			phoneErr: "",
			f2UserId: "",
			travelerId: "",
			mode: MODE.BIZ,
			miAppId: "",
		}

		this.onRequiredPapersChange = this.onRequiredPapersChange.bind(this);
		this.onRequiredPapersOtherChange = this.onRequiredPapersOtherChange.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.isWDTypes = this.isWDTypes.bind(this);

		this.booking = this.booking.bind(this);

	}


	onRequiredPapersChange = (event) => {
		const papers = ["cm_gp", "pp", "cccd_all"]; 
		var requiredPapers = ["cm_gp"];

		for (var i = 0; i < papers.length; ++i) {
			if (papers[i] === event.target.value) {
				requiredPapers.push(event.target.value); 
				this.setState({
					paper: event.target.value
				})
			}
		}


		this.setState({
			requiredPapers: requiredPapers
		})


	}

	onRequiredPapersOtherChange(event) {
	    this.setState({
	        requiredPapersOther: event.target.value
	    });
	}


	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	onInfoModeChange = (mode) => { 
		this.setState({
			mode
		})
	}

	
	
	isValidInfo(){
		let phoneErr = "";

		const { phoneNumber } = this.state;

	   
		if(!isPhoneValid(phoneNumber)){
			phoneErr = "Số điện thoại chưa hợp lệ"
		} 

		if(phoneErr) { 
			this.setState({phoneErr})
			return false
		}
		return true
	}


	isValidBooking = () => { 
		const { renterName, phoneNumber, email, requiredPapers, err, travelerId, miAppId} = this.state;
		const { car, endDate, startDate, stype } = this.props;

		if (stype === 1) { 
			return (car 
				&& ((renterName
				&& phoneNumber) || (travelerId && miAppId)) 
				&& endDate 
				&& startDate 
				&& car.carGroupPrice
				&& requiredPapers.length > 1)
		}
	
		return (car 
			&& ((renterName
			&& phoneNumber) || (travelerId && miAppId))
			&& endDate 
			&& startDate 
			&& car.carGroupPrice)
			
	}

	isWDTypes = () => {
		const { wdOneWay, wdMode } = this.props.filter;

		if (wdMode === 0) {
			return WDTypes[1]
		}

		if (wdMode === 1 && wdOneWay) {
			return WDTypes[2]
		}

		if (wdMode === 1 && !wdOneWay) {
			return WDTypes[3]
		}

		return WDTypes[0]
	}

	booking = (carGroupId, price) => {

		const { renterName, phoneNumber, email, requiredPapers, requiredPapersOther, f2UserId, mode, travelerId, miAppId } = this.state;
		const { car, wd, filter, stype, platformType, allowPlatformBooking } = this.props;
		const { lat, lng, wdDistance, wdLocations, wdOneWay, wdDistanceBackOW } = filter;
		
		const startDate = this.props.startDate.valueOf();
		const endDate = this.props.endDate.valueOf();
		const limitKM = stype === 2 ? wd.limitKM : null;
		var papers = requiredPapers.join(";");
		let info;

	

		if (mode == MODE.PLATFORM && allowPlatformBooking ) {
			info = {
				travelerId: travelerId,
				miAppId: miAppId,
				requiredPapers: papers,
				requiredPapersOther: encodeURI(requiredPapersOther),
				f2UserId: f2UserId,
			}
		} else {
			info = {
				tvlName: renterName,
				tvlPhone: phoneNumber,
				tvlEmail: email, 
				requiredPapers: papers,
				requiredPapersOther: encodeURI(requiredPapersOther),
				f2UserId: f2UserId
			}
			
			
		}

	

		// const isValid = this.isValidInfo(); 

		// if (isValid) { 
		// 	this.setState({
		// 		phoneErr: "", 
		// 	})
		// }

		
	
		bookCar(lat, lng, carGroupId, startDate, endDate, platformType, wdDistance, wdLocations, wdOneWay, wdDistanceBackOW, stype, limitKM, info).then(resp => {
				if (resp.data.error >= commonErr.SUCCESS) {	
					this.props.goToResult(resp.data.data.order);
				} else {
				
					this.props.goToError(resp.data.error, resp.data.errMsg);
				
				}
		});
	}
	

	render() {
		const { err, renterName, phoneNumber, phoneErr, email, paper, f2UserId, mode, travelerId, miAppId} = this.state;
		const { car, wd, filter, stype, startDate, endDate, platformType, listF2, allowPlatformBooking} = this.props
		const { address, wdDistance, addressArray } = filter 

		const isBiz = platformType === 1;
		const isSelfDrive = stype === 1;


		if (err !== commonErr.LOADING) {
	
			return <div className="row p-4">
							<div className="col-md-12"> 
								<h5 className="font-bold">{car.groupName}</h5>
							</div>
							<div className="col-md-4 item-car"> 
								<div className="fix-img mb-4" style={{ paddingBottom: "75%" }}>
									<img src={car.avatarUrl} />
									<span className="price"> <span className="font-weight-bold">{formatPrice(car.carGroupPrice)}</span> <span>{!isSelfDrive ? "/chuyến": ""}</span></span>	
								</div>
							</div>
							<div className="col-md-8"> 
								{isSelfDrive ? <div className="form-group mb-4">
									<label className="font-strong">ĐỊA ĐIỂM</label>
									<p>{address}</p>
								</div> 
								: <div className="form-group mb-4">
							<label className="font-strong">LỘ TRÌNH: {this.isWDTypes()}</label>
									<p>{addressArray[0]}</p>
									{addressArray[1] !== "" && addressArray.map((address, index) => {
										if (index === 0) return null
										return <p key={index} className="wrap-input">
											<i className="ic ic-sm-circle-fill" />
											{address}
										</p>
									})}
									{wdDistance > 0 && <p>Tổng lộ trình: {wdDistance} km</p>}
									{wd.limitKM > 0 && <p>Số km được đi: {wd.limitKM} km</p>}
									<p>Phí phụ thu vượt KM: 8,000/km</p>
									<p>Phí phụ thu vượt giờ: 100,000/h</p>
								</div>}
								<div className="form-group mb-4">
									<label className="font-strong">THỜI GIAN THUÊ XE</label>
									<div className="d-flex"> 
										<p className="w-50">Bắt đầu: {startDate.format("HH:mm - DD/MM/YYYY")}</p>
										<p className="w-50">Kết thúc: {endDate.format("HH:mm - DD/MM/YYYY")}</p>
									</div>
								</div>
								{isSelfDrive && <div className="mb-4">
									<p>Truyền động: {CarTransmission[filter.transmission]}</p>
									<p>Ngẫu nhiên trong các dòng xe sau: {car.groupDesc}</p>
								</div>}
				</div> 
				{!isBiz && listF2.length > 0 && <div className="col-md-12">
					<div className="form-group mb-4">
						<label className="font-strong">Đại lý F2</label>	
						<select className="form-control form-control-line" name="f2UserId" onChange={this.handleInputChange} value={f2UserId}>
							<option value="" disabled>Chọn đại lý F2 (nếu có)</option>
							{listF2.map(f2 => <option key={`s_${f2.profile.uid}`} value={f2.profile.uid}>{f2.profile.name}</option>)}
						</select>
					</div>
				</div>}
				{isSelfDrive && <div className="col-md-12">
					<label className="font-strong">GIỚI HẠN SỐ KM</label>
					<p>Giới hạn số km: <span className="font-strong">300km/ngày</span> - Phí phụ thu vượt KM: <span className="font-strong">5,000/km</span>. Phí phụ thu vượt giờ: <span className="font-strong">100,000/h</span></p>
				</div>}
				{isBiz && <div className="col-md-12">
					{allowPlatformBooking && <ul className="nav nav-tabs tabs-line tabs-line-2x nav-fill" style={{width: '100%'}}>
						<li className="nav-item">
							<a className={`nav-link ${mode == MODE.BIZ ? 'active' : ''}`} onClick={() => this.onInfoModeChange(MODE.BIZ)}>DOANH NGHIỆP</a>
						</li>
						<li className="nav-item">
							<a className={`nav-link ${mode == MODE.PLATFORM ? 'active' : ''}`} onClick={() => this.onInfoModeChange(MODE.PLATFORM)}>PLATFORM</a>
						</li>
					</ul>}

					<div className="tab-content">
						<div className={`w-100 tab-pane ${mode == MODE.BIZ ? 'fade show active' : ''}`}>
							<label className="font-strong">THÔNG TIN NHÂN VIÊN</label> 
							<div className="form-group mb-4">
							 	<label>Tên nhân viên</label>
								<input className="form-control form-control-line" type="text" name="renterName" value={renterName} onChange={this.handleInputChange}/>
							</div>
							<div className="form-group mb-4">
								<label>Số điện thoại </label>
								<input className="form-control form-control-line" type="text" name="phoneNumber" value={phoneNumber} onChange={this.handleInputChange}/>
								{phoneErr ? <span className="text-danger">{phoneErr}</span> : null}
							</div> 
							<div className="form-group mb-4">
								<label>Email </label>
								<input className="form-control form-control-line" type="text" name="email" value={email} onChange={this.handleInputChange}/>
							</div> 
						</div>
				
						<div className={`w-100 tab-pane ${mode == MODE.PLATFORM ? 'fade show active' : ''}`}>
							<div className="form-group mb-4">
								<label>User ID</label>
								<input className="form-control form-control-line" type="text" name="travelerId" value={travelerId} onChange={this.handleInputChange}/>
							</div>
							<div className="form-group mb-4">
								<label>Platform</label>
								<select className="form-control form-control-line" name="miAppId" onChange={this.handleInputChange} value={miAppId}>
									<option value="" disabled>Chọn Platform</option>
									{MiAppMap.map(miApp => <option key={`s_${miApp.key}`} value={miApp.key}>{miApp.value}</option>)}
								</select>
							</div>
						</div>
					</div>
				</div> }


				{!isBiz && <div className="col-md-12">
						 <label className="font-strong">THÔNG TIN KHÁCH THUÊ</label>
						<div className="form-group mb-4">
							<label>Tên khách thuê</label>
							<input className="form-control form-control-line" type="text" name="renterName" value={renterName} onChange={this.handleInputChange}/>
						</div>
						<div className="form-group mb-4">
							<label>Số điện thoại </label>
							<input className="form-control form-control-line" type="text" name="phoneNumber" value={phoneNumber} onChange={this.handleInputChange}/>
							{phoneErr ? <span className="text-danger">{phoneErr}</span> : null}
						</div> 
						<div className="form-group mb-4">
							<label>Email </label>
							<input className="form-control form-control-line" type="text" name="email" value={email} onChange={this.handleInputChange}/>
						</div> 
				</div>}
				{isSelfDrive && <React.Fragment><div className="col-md-12">
							<label className="font-strong">GIẤY TỜ THUÊ XE</label>
							<div className="form-group">
								<label className="checkbox mr-2">
									<input type="checkbox" name="pp" id="cm_pg" onChange={this.onRequiredPapersChange} checked disabled value="cm_gp"  /><span className="input-span" />		CMND và GPLX (đối chiếu)
								</label>
								{/* <label className="radio mr-2">
								<input type="radio" name="paper" id="hk" onChange={this.onRequiredPapersChange} value="hk" checked={paper === "hk"} /><span className="input-span" />		Sổ hộ khẩu (bản gốc)
								</label> */}
								{/* <label className="radio mr-2">
									<input type="radio" name="paper" id="hk_kt3" onChange={this.onRequiredPapersChange} value="hk_kt3" checked={paper === "hk_kt3"}   /><span className="input-span" /> KT3 (bản gốc)
								</label> */}
								<label className="radio mr-2">
									<input type="radio" name="paper" id="pp" onChange={this.onRequiredPapersChange} value="pp"  checked={paper === "pp"}  /><span className="input-span" />		Passport (giữ lại)
								</label>
								<label className="radio mr-2">
									<input type="radio" name="paper" id="cccd_all" onChange={this.onRequiredPapersChange} value="cccd_all" checked={paper === "cccd_all"}   /><span className="input-span" /> CCCD gắn chip (đôi chiếu)
								</label>
							</div>
					</div>
					
					<div className="col-md-12 mb-4">
						<label>Giấy tờ khác</label>
						<input type="text" name="papers_other" onChange={this.onRequiredPapersOtherChange} className="form-control form-control-line" />
					</div>	
				</React.Fragment>}
				<div className="col-md-12 text-center">
					<button className="btn btn-primary" disabled={!this.isValidBooking()} onClick={() => this.booking(car.id)}>Đặt xe</button>
				</div>
			</div>
		}
	}
}

class ConfirmBooking extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			step: 1,
			trip: null
		}
		this.goToResult = this.goToResult.bind(this);
		this.goToError = this.goToError.bind(this);
		this.close = this.close.bind(this);
	}
	goToResult(trip) {
		this.setState({
			step: 2,
			trip: trip
		});
	}

	goToError(err, errMsg) {
		this.setState({
			step: 2,
			err: err,
			errMsg: errMsg
		});
	}

	close() {
		this.props.onHide();
		window.location.reload();
	}

	render() {
		var content;
		var title;
		var modalClass;

		if (this.state.err === commonErr.LOADING) {
			content = <section className="body">
				<div>Loading</div>
			</section>
		} else {
			const { err, errMsg, step, trip } = this.state
			const { cars, filter, popupId, stype, startDate, endDate, platformType, wd, allowPlatformBooking } = this.props;
			const { listF2 } = this.props.listF2;

			var car;
			if (cars && cars.length > 0) {
				for (var i = 0; i < cars.length; i++) {
					if (cars[i].id === popupId) {
						car = cars[i];
						break;
					}
				}
			}
		
			switch (step) {
				case 2:
					content = <BookingResult
						err={err}
						errMsg={errMsg}
						car={car}
						close={this.close}
						trip={trip}
					/>
					title = "Thông báo"
					modalClass = "modal-md"
					break; 
				default:
					content = <BookingDetail
						car={car}
						wd={wd}
						filter={filter}
						stype={stype}
						startDate={startDate}
						endDate={endDate}
						platformType={platformType}
						goToResult={this.goToResult}
						goToError={this.goToError}
						listF2={listF2}
						allowPlatformBooking={allowPlatformBooking}
					/>
					title = "Xác nhận đặt xe"
					modalClass = "modal-lg modal-confirm"
			}
		}

		return (
			<Modal
			show={this.props.show}
			onHide={this.close}
			dialogClassName={`modal-dialog modal-insurance ${modalClass}`}
			aria-labelledby="ModalHeader"	
		>
			<Modal.Header id='ModalHeader' closeButton={true} closeLabel={""}>
					<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{content}
			</Modal.Body>
		</Modal>
		)
	}
}

function mapState(state) {
	return {
		listF2: state.listF2
	}
}

ConfirmBooking = connect(mapState)(ConfirmBooking)

export default ConfirmBooking


// WEBPACK FOOTER //
// ./src/components/car/confirmbooking.js